
import { toLower, toUpper } from "ramda";


export const AsyncroDocumentsTable = [
  { name: 'Person', label: 'Person', minWidth: 100, align: "center" },
  { name: 'Tipo_Estudiante', label: 'Tipo Estudiante', minWidth: 100, align: "center" },
  { name: 'Matricula', label: 'Matricula', minWidth: 100, align: "center" },
  { name: 'Nombre', label: 'Nombre', minWidth: 100, align: "center" },
  { name: 'Correos', label: 'Correos', minWidth: 180, align: "center" },
  { name: 'Nivel', label: 'Nivel', minWidth: 80, align: "center" },
  { name: 'Codigo_Programa', label: 'Código Programa', minWidth: 150, align: "center" },
  { name: 'Nombre_programa', label: 'Nombre Programa', minWidth: 180, align: "center" },
  { name: 'Fecha_Inscripcion_Programa', label: 'Fecha Inscripción Programa', minWidth: 170, align: "center" },
  { name: 'Plazo', label: 'Plazo', minWidth: 90, align: "center" },
  { name: 'Fecha_Vencimiento_Membresia', label: 'Fecha Vencimiento Membresía', minWidth: 180, align: "center" },
  { name: 'Ultima_Conexion', label: 'Última Conexión', minWidth: 140, align: "center" },
  { name: 'Curso', label: 'Curso', minWidth: 90, align: "center" },
  { name: 'Nombre_Materia', label: 'Nombre Materia', minWidth: 180, align: "center" },
  { name: 'Fecha_Inscripcion_materia', label: 'Fecha Inscripción Materia', minWidth: 170, align: "center" },
  { name: 'PeriodoMateria', label: 'Periodo Materia', minWidth: 120, align: "center" },
  { name: 'Unidad', label: 'Unidad', minWidth: 90, align: "center" },
  { name: 'Calificacion', label: 'Calificación', minWidth: 110, align: "center" },
  { name: 'DocAdmEnEscolar', label: 'Documentación Escolar', minWidth: 160, align: "center" },
  { name: 'FechaEntregaDocumentos', label: 'Fecha Entrega Documentos', minWidth: 170, align: "center" },
]



export const excelAsyncroDocuments = [
  {
    column: "Person",
    type: Number,
    value: (datasource) => datasource?.Person || '',
    width: 60
  },
  {
    column: "Tipo Estudiante",
    type: String,
    value: (datasource) => toUpper(datasource?.Tipo_Estudiante || ''),
    width: 60
  },
  {
    column: "Matricula",
    type: String,
    value: (datasource) => toUpper(datasource?.Matricula) || '',
    width: 60
  },
  {
    column: "Nombre",
    type: String,
    value: (datasource) => toUpper(datasource?.Nombre || ''),
    width: 60
  },
  {
    column: "Correos",
    type: String,
    value: (datasource) => toUpper(datasource?.Correos || ''),
    width: 60
  },
  {
    column: "Nivel",
    type: String,
    value: (datasource) => toUpper(datasource?.Nivel || ''),
    width: 60
  },
  {
    column: "Código Programa",
    type: String,
    value: (datasource) => toUpper(datasource?.Codigo_Programa || ''),
    width: 60
  },
  {
    column: "Nombre Programa",
    type: String,
    value: (datasource) => toUpper(datasource?.Nombre_programa || ''),
    width: 60
  },
   {
    column: "Fecha Inscripción Programa",
    type: String,
    value: (datasource) => toUpper(datasource?.Fecha_Inscripcion_Programa || ''),
    width: 60
  },
  {
    column: "Plazo",
    type: String,
    value: (datasource) => toUpper(datasource?.Plazo || ''),
    width: 60
  },
   {
    column: "Fecha Vencimiento Membresía",
    type: String,
    value: (datasource) => toUpper(datasource?.Fecha_Vencimiento_Membresia || ''),
    width: 60
  },
   {
    column: "Última Conexión",
    type: String,
    value: (datasource) => toUpper(datasource?.Ultima_Conexion || ''),
    width: 60
  },
  {
    column: "Curso",
    type: Number,
    value: (datasource) => datasource?.Curso || '',
    width: 60
  },
   {
    column: "Nombre Materia",
    type: String,
    value: (datasource) => toUpper(datasource?.Nombre_Materia || ''),
    width: 60
  },
   {
    column: "Fecha Inscripción Materia",
    type: String,
    value: (datasource) => toUpper(datasource?.Fecha_Inscripcion_materia || ''),
    width: 60
  },
  {
    column: "Periodo Materia",
    type: String,
    value: (datasource) => toUpper(datasource?.PeriodoMateria || ''),
    width: 60
  },
  {
    column: "Unidad",
    type: String,
    value: (datasource) => toUpper(datasource?.Unidad || ''),
    width: 60
  },
  {
    column: "Calificacion",
    type: String,
    value: (datasource) => toUpper(datasource?.Calificacion || ''),
    width: 60
  },
  {
    column: "Documentación Escolar",
    type: String,
    value: (datasource) => toUpper(datasource?.DocAdmEnEscolar || ''),
    width: 60
  },
   {
    column: "Fecha Entrega Documentos",
    type: String,
    value: (datasource) => toUpper(datasource?.FechaEntregaDocumentos || ''),
    width: 60
  },




]